(function () {
  'use strict';
  if (window.__csMobileChatClearance) return;
  window.__csMobileChatClearance = true;

  function attachChatEvents() {
    var api = window.tidioChatApi;
    if (!api || api.__csClearanceEvents) return;
    api.__csClearanceEvents = true;
    function markOpen() { document.body.classList.add('cs-tidio-open'); }
    function markClosed() { document.body.classList.remove('cs-tidio-open'); }
    // Move only the closed launcher. Restore the conversation's full height
    // before it opens; never hide the chat or alter its conversation state.
    api.on('beforeOpen', markOpen);
    api.on('open', markOpen);
    api.on('close', markClosed);
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', attachChatEvents);
  } else {
    document.addEventListener('tidioChat-ready', attachChatEvents);
  }
})();
